<template>
    <div class="layer">
        <div class="wrap">
            <div class="agree_layer">
                <div class="agree_wrap">
                    <img class="logo" src="@/assets/largeLogo.png" alt="" />
                    <div class="title">약관동의</div>
                    <div class="all_agree" :class="checkbox.all ? 'active' : ''" @click="onCheck(0)">
                        <label class="agree_check">
                            <div class="checkbox" :class="checkbox.all ? 'active' : ''"></div>
                            전체동의
                        </label>
                    </div>
                    <div class="agree_content">
                        <div class="agree_detail">
                            <div class="detail_title">
                                <label class="agree_check" @click="onCheck(1)">
                                    <div class="checkbox" :class="checkbox[1] ? 'active' : ''"></div>
                                    <p>
                                        <span :class="checkbox[1] ? 'bold' : ''">
                                            이용약관
                                            <span class="required">(필수)</span>
                                        </span>
                                    </p>
                                </label>
                            </div>
                            <div class="detail_content">
                                <div disabled v-html="terms.use" class="terms"></div>
                            </div>
                        </div>

                        <div class="agree_detail">
                            <div class="detail_title">
                                <label class="agree_check" @click="onCheck(2)">
                                    <div class="checkbox" :class="checkbox[2] ? 'active' : ''"></div>
                                    <p>
                                        <span :class="checkbox[2] ? 'bold' : ''">
                                            개인정보처리방침
                                            <span class="required">(필수)</span>
                                        </span>
                                    </p>
                                </label>
                            </div>
                            <div class="detail_content">
                                <div disabled v-html="terms.privacy" class="terms"></div>
                            </div>
                        </div>
                    </div>
                    <div class="agree_btn" @click="onAccept" :class="checkbox.all ? '' : 'off'">승인요청</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts" config>
    import { apiService, reactive, router, userStore, watch } from "@/BaseComponent";

    export default {
        props: {},
        components: {},
        setup() {
            const user = userStore();
            const checkbox = reactive({
                all: false,
                1: false,
                2: false,
            });

            const terms = reactive({
                use:
                    "<p class = 'main_title'>제1장 총칙</p>" +
                    "<p class = 'title'>제1조 (목적)</p>" +
                    '<p>이 약관은 서울특별시 다시함께상담센터 (이하 "다시함께상담센터"라 합니다) 사이트가 제공하는 통합회원 서비스(이하 "서비스"라 합니다)를 이용함에 있어 이용자와 다시함께상담센터간의 권리·의무 및 책임사항과 기타 필요한 사항을 규정함을 목적으로 합니다.</p>' +
                    "<p class = 'title'>제2조 (약관의 효력 및 변경)</p>" +
                    "<p>① 이 약관은 서비스 화면에 게시하거나 기타의 방법으로 공지함으로써 이용자에게 공시하고, 이에 동의한 이용자가 서비스에 가입함으로써 효력이 발생합니다.</p>" +
                    "<p>② 다시함께상담센터는 필요하다고 인정되는 경우 이 약관의 내용을 변경할 수 있습니다.</p>" +
                    "<p>③ 변경된 약관은 전항과 같은 방법으로 효력이 발생합니다.</p>" +
                    "<p>④ 이용자가 이 약관의 내용에 동의하는 경우 다시함께상담센터의 서비스 제공행위 및 이용자의 서비스 이용행위에는 이 약관이 우선적으로 적용될 것입니다. 이 약관에 명시되지 않은 사항에 대해서는 전기통신기본법, 전기통신사업법, 정보통신망이용촉진및정보보호등에관한법률, 방송통신심의위원회 심의규정, 정보통신 윤리강령, 프로그램 보호법 등 기타 대한민국의 관련법령과 상관습에 의합니다.</p>" +
                    "<p class = 'title'>제3조 (용어의 정의)</p>" +
                    "<p>① 이 약관에서 사용하는 용어의 정의는 다음과 같습니다.</p>" +
                    "<p>1. 이용자 : 서비스에 접속하여 다시함께상담센터가 제공하는 서비스를 받는 회원</p>" +
                    "<p>2. 회원 : 서비스에 접속하여 이 약관에 동의하고, ID(고유번호)와 PASSWORD(비밀번호)를 발급 받아 문자 인증 등 확인 절차를 거친 자</p>" +
                    "<p>3. ID(고유번호) : 회원 식별과 회원의 서비스 이용을 위하여 이용자가 선정하고 다시함께상담센터가 승인하는 영문자와 숫자의 조합</p>" +
                    "<p>4. PASSWORD(비밀번호) : 회원의 정보 보호를 위해 이용자 자신이 설정한 문자와 숫자의 조합</p>" +
                    "<p>5. 이용해지 : 다시함께상담센터 또는 회원이 서비스 이용 이후 그 이용계약을 종료시키는 의사표시</p>" +
                    "<p>② 이 약관에서 사용하는 용어의 정의는 제1항에서 정하는 것을 제외하고는 관계법령 및 서비스별 안내에서 정하는 바에 의합니다.</p>" +
                    "<p class = 'main_title'>제2장 서비스 이용계약</p>" +
                    "<p class = 'title'>제4조 (이용계약의 성립) 이용계약은 이용자의 약관내용에 대한 동의와 이용자의 이용신청에 대한 다시함께상담센터의 승낙으로 성립합니다.</p>" +
                    "<p class = 'title'>제5조 (이용신청) 이용신청은 서비스의 회원정보 화면에서 이용자가 다시함께상담센터에서 요구하는 가입신청 양식에 개인의 신상정보를 기록하는 방식으로 신청합니다.</p>" +
                    "<p class = 'title'>제6조 (이용신청의 수락과 거절)</p>" +
                    "<p>① 다시함께상담센터는 직무에 필요하다고 판단된 이용자에 한하여 이용신청을 수락합니다.</p>" +
                    "<p>② 다시함께상담센터는 다음 각 호에 해당하는 경우에 대하여는 그 신청에 대한 제한 사유가 해소될 때까지 일부 서비스 이용을 제한할 수 있습니다.</p>" +
                    "<p>1. 내용이 허위(차명 등)인 것으로 판명되거나, 그러하다고 의심할만한 합리적인 사유가 발생할 경우</p>" +
                    "<p>2. 기타 다시함께상담센터가 필요하다고 인정되는 경우</p>" +
                    "<p>③ 다시함께상담센터는 다음에 해당하는 경우에는 이용신청을 제한할 수 있습니다.</p>" +
                    "<p>1. 다른 사람의 명의를 사용하여 신청하였을 때</p>" +
                    "<p>2. 신상정보의 내용을 허위로 기재하였을 때</p>" +
                    "<p>3. 기타 다시함께상담센터가 정한 이용신청 요건이 미비 되었을 때</p>" +
                    "<p class = 'title'>제7조 (계약사항의 변경) 회원은 회원정보관리를 통해 언제든지 자신의 정보를 열람하고 수정할 수 있습니다. 회원은 이용신청 시 기재한 사항이 변경되었을 때에는 다시함께상담센터에 보고 후 수정을 하여야 합니다.</p>" +
                    "<p class = 'main_title'>제3장 서비스 제공 및 이용</p>" +
                    "<p class = 'title'>제8조 (게시물의 저작권)</p>" +
                    "<p>① 회원이 서비스 내에 게시한 게시물 및 서비스 자체적으로 수집한 게시물의 저작권은 다시함께상담센터이 있습니다.</p>" +
                    "<p>② 회원은 서비스를 이용하여 얻은 정보를 가공, 판매하는 행위 등 서비스에 게재된 자료를 상업적으로 사용할 수 없습니다.</p>" +
                    "<p class = 'title'>제9조 (다시함께상담센터의 소유권)</p>" +
                    "<p>① 다시함께상담센터가 제공하는 서비스, 그에 필요한 소프트웨어, 이미지, 마크, 로고, 디자인, 서비스명칭, 정보 및 상표 등과 관련된 지적재산권 및 기타권리는 다시함께상담센터에게 소유권이 있습니다.</p>" +
                    "<p>② 회원은 다시함께상담센터가 명시적으로 승인한 경우를 제외하고는 제1항 소정의 각 재산에 대한 전부 또는 일부의 수정, 대여, 대출, 판매, 배포, 제작, 양도, 재라이센스, 담보권 설정행위, 상업적 이용행위를 할 수 없으며, 제3자로 하여금 이와 같은 행위를 하도록 허락할 수 없습니다.</p>" +
                    "<p class = 'main_title'>제4장 계약 당사자의 의무</p>" +
                    "<p class = 'title'>제10조 (개인정보보호정책)</p>" +
                    "<p>① 다시함께상담센터는 이용 신청 시 회원이 제공하는 정보를 통하여 회원에 관한 정보를 수집하며, 회원의 개인정보는 본 이용계약의 이행과 본 이용계약상의 서비스제공을 위한 목적으로 이용합니다.</p>" +
                    "<p>② 다시함께상담센터는 서비스 제공과 관련하여 취득한 회원의 정보를 본인의 승낙 없이 제3자에게 누설 또는 배포할 수 없으며 상업적 목적으로 사용할 수 없습니다. 다만, 다음의 각 호의 경우에는 그러하지 아니합니다.</p>" +
                    "<p>1. 관계 법령에 의하여 수사상의 목적으로 관계기관으로부터 요구가 있는 경우</p>" +
                    "<p>2. 방송통신심의위원회의 요청이 있는 경우</p>" +
                    "<p>3. 기타 관계법령에서 정한 절차에 따른 요청이 있는 경우</p>" +
                    "<p class = 'main_title'>제5장 계약해지</p>" +
                    "<p class = 'title'>제11조 (계약해지 및 이용제한)</p>" +
                    "<p>① 회원이 이용계약을 해지하고자 하실 때에는 관리자에게 요청하여야 합니다.</p>" +
                    "<p>1. 회원의 직무가 변경되어 서비스를 이용할 필요가 없어질 경우</p>" +
                    "<p>2. 회원이 퇴사하여 서비스를 이용할 필요가 없어질 경우</p>" +
                    "<p>② 다시함께상담센터는 보안 및 아이디 정책, 서비스의 원활한 제공 등과 같은 이유로 회원의 ID 및 PASSWORD 변경을 요구하거나 변경할 수 있습니다.</p>" +
                    "<p>③ 다시함께상담센터는 회원이 다음 각호에 해당하는 행위를 하였을 경우 사전통지 없이 이용계약을 해지할 수 있습니다.</p>" +
                    "<p>1. 회원이 제공한 데이터가 허위임이 판명된 경우</p>" +
                    "<p>2. 범죄적 행위에 관련되는 경우</p>" +
                    "<p>3. 국익 또는 사회적 공익을 저해할 목적으로 서비스 이용을 계획 또는 실행할 경우</p>" +
                    "<p>4. 타인의 서비스 아이디 및 비밀번호를 도용한 경우</p>" +
                    "<p>5. 타인의 명예를 손상하거나 불이익을 주는 경우</p>" +
                    "<p>6. 서비스에 위해를 가하는 등 서비스의 건전한 이용을 저해하는 경우</p>" +
                    "<p>7. 기타 관련 법령이나 다시함께상담센터가 정한 이용 조건에 위배되는 경우</p>" +
                    "<p class = 'main_title'>제6장 기타</p>" +
                    "<p class = 'title'>제12조 (양도금지)</p>" +
                    "<p>회원은 서비스의 이용권한, 기타 이용계약상의 지위를 타인에게 양도, 증여할 수 없습니다.</p>" +
                    "<p></p>" +
                    "<p>부 칙</p>" +
                    "<p>(시행일) 이 약관은 2024년 00월 00일부터 적용합니다.</p>",
                privacy:
                    "<p class='main_title'>개인정보처리방침</p>" +
                    "<p class='title'>다시함께상담센터는 「개인정보보호법」 제30조에 따라 이용자의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같은 처리방침을 두고 있습니다. 다만 아래에 기재되지 않은 사항의 경우 국가인권위원회 홈페이지의 「개인정보처리방침」을 준용합니다.</p>" +
                    "<p>※ 본 방침은 2024년 00월 00일부터 시행됩니다.</p>" +
                    "<p class='main_title'>개인정보 처리 및 보유기간</p>" +
                    "<p class='title'>다시함께상담센터는 법령에 따른 개인정보 보유·이용기간 또는 이용자로부터 개인정보를 수집시에 동의 받은 개인정보 보유·이용기간 내에서 개인정보를 처리, 보유합니다.</p>" +
                    "<p class='middle-title'> 수집항목 </p>" +
                    "<p class='middle-content'> 회원: 아이디, 비밀번호, 소속팀, 직위, 중복가입확인정보(ID)</p>" +
                    "<p class='middle-content'> 자동수집: 접속 로그, 쿠키, 접속 IP 정보</p>" +
                    "<p class='middle-title'>수집 및 이용 목적</p>" +
                    "<p class='middle-content'>회원 중복가입 방지, 서비스 사용권한 부여, 회원 통합관리</p>" +
                    "<p class='middle-title'>보유 기간</p>" +
                    "<p class='middle-content'>회원 탈퇴시 까지</p>",
            });
            const onCheck = (idx: number) => {
                switch (idx) {
                    case 0:
                        if (checkbox.all) {
                            checkbox[1] = checkbox[2] = false;
                        } else if (!checkbox.all) {
                            checkbox[1] = checkbox[2] = true;
                        }
                        break;
                    case 1:
                        checkbox[1] = !checkbox[1];
                        break;
                    case 2:
                        checkbox[2] = !checkbox[2];
                        break;

                    default:
                        break;
                }
            };
            watch(checkbox, () => {
                if (checkbox[1] && checkbox[2]) {
                    checkbox.all = true;
                } else {
                    checkbox.all = false;
                }
            });
            const onAccept = async () => {
                if (checkbox.all) {
                    const res = await apiService.base.accept();
                    if (res.returnCode === 0) {
                        alert("승인요청이 전송되었습니다.\n관리자 승인 후 로그인가능합니다.");
                        router.replace("/login");
                    } else if (res.returnCode === 13) {
                        alert("이미 승인요청한 계정입니다\n로그인 페이지로 이동됩니다.");
                        router.replace("/login");
                        user.setToken(null);
                    }
                } else if (!checkbox[1]) {
                    alert("이용약관에 동의 해주세요");
                } else if (!checkbox[2]) {
                    alert("개인정보처리방침에 동의 해주세요");
                }
            };
            return {
                checkbox,
                onCheck,
                onAccept,
                terms,
            };
        },
    };
</script>
